import type { WhatsAppTemplateData } from '@jobilla/nexus-sdk'
import { useTranslation } from 'react-i18next'
import { getTemplateBodyText } from './template-body'

// Generic templates share one fixed layout: {{1}} recipient, {{2}} job title, {{3}} company.
const GENERIC_FIELD_LABEL_KEYS: Record<string, string> = {
	'1': 'whatsappSettings.autofillManagedFieldRecipient',
	'2': 'whatsappSettings.autofillManagedFieldJobTitle',
	'3': 'whatsappSettings.autofillManagedFieldCompany',
}

export function TemplateAutofillManagedNote({ template }: { template: WhatsAppTemplateData }) {
	const { t } = useTranslation('common')
	const bodyText = getTemplateBodyText(template)
	const segments = bodyText.split(/(\{\{\d+\}\})/g)

	return (
		<div className="mt-3 p-4 rounded-lg border border-gray-200 bg-gray-50/60 space-y-3">
			<div>
				<div className="text-sm font-medium text-gray-700">
					{t('whatsappSettings.autofillManagedTitle')}
				</div>
				<div className="mt-1 text-sm text-gray-500">
					{t('whatsappSettings.autofillManagedDescription')}
				</div>
			</div>

			{bodyText && (
				<div className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">
					{segments.map((segment, index) => {
						const placeholder = segment.match(/^\{\{(\d+)\}\}$/)
						if (!placeholder) {
							return <span key={`${index}-text`}>{segment}</span>
						}

						const labelKey = GENERIC_FIELD_LABEL_KEYS[placeholder[1]]
						return (
							<span
								key={`${index}-slot`}
								className="rounded bg-purple-100 px-1 py-0.5 font-medium text-purple-700"
							>
								{labelKey ? t(labelKey) : segment}
							</span>
						)
					})}
				</div>
			)}
		</div>
	)
}
